import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import RangePickerInput from '../../common/RangePickerInput'; // Adjust the path accordingly

const RangePickerInputComponent = () => {
    return (
        <div className="page-content components">
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Range Picker Input Showcase</h2>

                        {/* First Row - Default Range Picker Input */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <RangePickerInput
                                    label="Default Range"
                                    onChange={(min, max) => console.log("Selected range:", min, max)}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<RangePickerInput
    label="Default Range"
    onChange={(min, max) => console.log("Selected range:", min, max)}
/>
                                    `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row - Required Range Picker Input */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <RangePickerInput
                                    label="Required Range"
                                    required={true}
                                    onChange={(min, max) => console.log("Selected range:", min, max)}
                                    showHelp={true}
                                    helpText="This range is required."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<RangePickerInput
    label="Required Range"
    required={true}
    onChange={(min, max) => console.log("Selected range:", min, max)}
    showHelp={true}
    helpText="This range is required."
/>
                                    `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row - Custom Range Picker Input */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <RangePickerInput
                                    label="Custom Range"
                                    start={0}
                                    end={100}
                                    min={10}
                                    max={90}
                                    onChange={(min, max) => console.log("Selected range:", min, max)}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<RangePickerInput
    label="Custom Range"
    start={0}
    end={100}
    min={10}
    max={90}
    onChange={(min, max) => console.log("Selected range:", min, max)}
/>
                                    `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row - Range Picker with Error Messages */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <RangePickerInput
                                    label="Range with Errors"
                                    required={true}
                                    start={0}
                                    end={100}
                                    min={20}
                                    max={80}
                                    onChange={(min, max) => console.log("Selected range:", min, max)}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<RangePickerInput
    label="Range with Errors"
    required={true}
    start={0}
    end={100}
    min={20}
    max={80}
    onChange={(min, max) => console.log("Selected range:", min, max)}
/>
                                    `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fifth Row - Range Picker with Custom Color */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <RangePickerInput
                                    label="Colored Range Picker"
                                    color="#28a745"
                                    start={0}
                                    end={100}
                                    onChange={(min, max) => console.log("Selected range:", min, max)}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<RangePickerInput
    label="Colored Range Picker"
    color="#28a745"
    start={0}
    end={100}
    onChange={(min, max) => console.log("Selected range:", min, max)}
/>
                                    `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default RangePickerInputComponent;
